
import { InputSwitch } from 'primereact/inputswitch';


const AppSwitch = (props) => {

    return(        
        <div className={(props?.className || "") + " flex align-items-center justify-content-between"}>
            <div>{props?.titulo || "ordena"}</div>
            <InputSwitch style={{marginLeft:'10px', flexShrink: '0'}} 
                checked={props?.valor} onChange={(e) => props?.setValor(e.value)}/>
        </div>    
    );
}

export default AppSwitch;